import Vue from 'vue'
import App from './App.vue'
import {
  BootstrapVue
} from "bootstrap-vue";
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSmoothScroll from 'vue2-smooth-scroll'
import Vuelidate from 'vuelidate'
import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  faAngleDoubleRight,
  faAngleDoubleDown,
  faTimes,
  faStar,
  faSortDown,
  faEquals,
  faCaretRight,
  faChevronRight,
  faChevronLeft,
  faHome,
  
} from '@fortawesome/free-solid-svg-icons'
import VueCardFormat from 'vue-credit-card-validation';
import { faClock ,  faEye} from '@fortawesome/free-regular-svg-icons'

import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import router from './router'
import titleMixin from './assets/js/titleMixin'


Vue.mixin(titleMixin)

Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);
Vue.use(VueSmoothScroll);
Vue.use(Vuelidate);
Vue.use(VueCardFormat);
library.add(
  faEye, faAngleDoubleRight,faAngleDoubleDown, faTimes, faStar, faSortDown, faEquals, faCaretRight, faChevronRight, faChevronLeft, faClock, faHome
)
Vue.component('font-awesome-icon', FontAwesomeIcon)


  
  
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
